"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _myAccountMenu = _interopRequireDefault(require("./my-account-menu/my-account-menu"));

var _myAccountMenuItems = _interopRequireDefault(require("./my-account-menu-items.shape"));

const MyAccount = props => {
  const {
    fullName,
    storeName,
    storeUrl,
    menuTypes,
    onOpen,
    onSelect
  } = props;
  const [showMenu, setShowMenu] = (0, _react.useState)(false);

  const onDocumentClick = e => {
    if (!showMenu) {
      return;
    }

    if (!e.target.closest('.my-account')) {
      setShowMenu(false);
    }
  };

  (0, _react.useEffect)(() => {
    document.addEventListener('click', onDocumentClick);
    return () => {
      document.removeEventListener('click', onDocumentClick);
    };
  });

  const toggleMenu = () => {
    setShowMenu(!showMenu);

    if (!showMenu) {
      onOpen();
    }
  };

  const onMenuSelect = value => {
    toggleMenu();
    onSelect(value);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "my-account"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "my-account__user",
    onClick: toggleMenu
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('my-account__full-name', {
      'my-account__full-name--selected': showMenu
    })
  }, fullName), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('my-account__user-arrow', {
      'my-account__user-arrow--selected': showMenu
    })
  })), /*#__PURE__*/_react.default.createElement(_myAccountMenu.default, {
    storeName: storeName,
    storeUrl: storeUrl,
    className: (0, _classnames.default)({
      'my-account-menu--hidden': !showMenu
    }),
    onSelect: onMenuSelect,
    menuTypes: menuTypes
  }));
};

MyAccount.propTypes = {
  fullName: _propTypes.default.string.isRequired,
  storeName: _propTypes.default.string.isRequired,
  storeUrl: _propTypes.default.string.isRequired,
  onOpen: _propTypes.default.func.isRequired,
  onSelect: _propTypes.default.func.isRequired,
  menuTypes: _myAccountMenuItems.default.isRequired
};
var _default = MyAccount;
exports.default = _default;